













import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
class GuideModal extends Vue {
  @Prop() visible!: boolean;

  @Watch("$route", { deep: true })
  handleRouteChange() {
    setTimeout(() => {
      this.draw();
    }, 200);
  }

  draw() {
    const wrapper = this.$refs.canvas_wrapper as any;
    if (!wrapper) {
      return;
    }

    const canvas = this.$refs.guide_canvas as HTMLCanvasElement;
    const { width: cw, height: ch } = wrapper.$el.getBoundingClientRect();
    const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
    const dpr = devicePixelRatio || 1;

    canvas.width = cw * dpr;
    canvas.height = ch * dpr;

    canvas.style.width = cw + "px";
    canvas.style.height = ch + "px";

    ctx.scale(dpr, dpr);

    function drawArrowLink(startX, startY, endX, endY) {
      ctx.save();
      ctx.lineWidth = 2;
      ctx.lineCap = "round";
      ctx.strokeStyle = "#ffffff";
      ctx.fillStyle = "#ffffff";

      // draw line
      ctx.beginPath();
      ctx.moveTo(startX, startY);
      ctx.bezierCurveTo(200, -200, -200, 500, endX, endY);
      ctx.stroke();
      ctx.closePath();

      // draw arrow
      ctx.beginPath();
      ctx.translate(endX + 10, endY - 10 * Math.cos((15 * Math.PI) / 180));
      ctx.rotate((45 * Math.PI) / 180);
      ctx.lineTo(
        -20 * Math.sin((15 * Math.PI) / 180),
        20 * Math.cos((15 * Math.PI) / 180)
      );
      ctx.lineTo(
        20 * Math.sin((15 * Math.PI) / 180),
        20 * Math.cos((15 * Math.PI) / 180)
      );
      ctx.lineTo(0, 0);
      ctx.fill();
      ctx.closePath();
      ctx.restore();
    }

    function drawText(text) {
      ctx.save();
      ctx.fillStyle = "#fff";
      ctx.font = "20px DINPro, 'SF UI Display'";

      const tw = ctx.measureText(text).width;
      ctx.fillText(text, (cw - tw) / 2, ch * 0.5);
      ctx.restore();
    }

    drawArrowLink(cw * 0.5, ch * 0.4, cw - 105, 45);
    drawText(this.$t("invite.share"));
  }

  mounted() {
    this.draw();
  }

  handleCancel() {
    this.$helper.toFusionPath(this, "basis", {
      name: "mine"
    });
  }
}
export default GuideModal;
